import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stone-100 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-195" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-196" data-mp="30j0qr08ey70g">
        <div className="text-center" data-id="element-197" data-mp="2vpg2w10jatez">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-emerald-950 sm:text-4xl" data-id="element-198" data-mp="2voehp3pt0qjj">
            ¿Te suena conocido esto?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-stone-900" data-id="element-199" data-mp="35fr6fmgb30lc">
            Domingo a las 11 de la noche. Mañana tienes clase de petróleo y gas. Y todavía estás buscando cómo explicar
            la diferencia entre upstream y downstream, cómo funcionan los pozos o por qué la seguridad petrolera es
            importante sin que tus alumnos se duerman o no entiendan nada.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-stone-700" data-id="element-200" data-mp="1k52ak3szwhgo">
            No es tu culpa. Es que llevas años peleando con materiales desorganizados, teoría densa en libros viejos y
            recursos pensados para otros contextos que después tienes que reescribir entero.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-stone-200 bg-white p-6 shadow-sm shadow-stone-900/5 sm:p-8" data-id="element-201" data-mp="x4i66tpxiaxy">
          <p className="mb-5 inline-flex items-center gap-2 font-serif text-xl font-bold tracking-tight text-emerald-950" data-id="element-202" data-mp="1c1j1f77bwo16">
            <AlertTriangleIcon className="h-5 w-5 text-stone-700" aria-hidden="true" data-id="element-203" data-mp="1g2ugwjwhnsvn" />
            El costo de no tener el material correcto:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-204" data-mp="3huh9gpw13vu8">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-stone-900" data-id="element-205" data-mp="p0937xmc7khp">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-600" aria-hidden="true" data-id="element-206" data-mp="k15ua238ku4g" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-207" data-mp="xym4zpskfa20">
          <p className="text-lg font-bold text-stone-800" data-id="element-208" data-mp="tyahm58tivmu">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tienes. Ahora te falta la herramienta.
          </p>
          <p className="mt-3 font-serif text-2xl font-extrabold tracking-tight text-emerald-950 sm:text-3xl" data-id="element-209" data-mp="130jsiw800r0r">
            Planifica todo tu año{' '}
            <span className="text-emerald-800 underline decoration-amber-500 decoration-4 underline-offset-4" data-id="element-210" data-mp="1ho4tajheie5i">hoy.</span>
          </p>
        </div>
      </div>
    </section>;
}